import { BoardInviteRestrictValues } from 'app/scripts/views/organization/constants';

const DisabledReasonsEnum = {
  NONE: 'none',
  RESTRICT_ORG: 'org-restrict-org',
  RESTRICT_MANAGED: 'org-restrict-managed',
  RESTRICT_MANAGED_OR_ORG: 'org-restrict-managed-or-org',
  GUEST_INVITE: 'guest-invite',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getInviteRestrictionReason = (org: any, member: any) => {
  let orgInviteRestrict;
  if (org && (orgInviteRestrict = org.getPref('boardInviteRestrict'))) {
    const isInOrg =
      member.attributes.idOrganizations !== null
        ? member.attributes.idOrganizations.some(
            (idOrg: string) => idOrg === org.get('id'),
          )
        : undefined;
    const isInEnt =
      member.attributes.idEnterprise !== null &&
      member.attributes.idEnterprise === org.get('idEnterprise');
    if (orgInviteRestrict === BoardInviteRestrictValues.ORG) {
      return !isInOrg
        ? DisabledReasonsEnum.RESTRICT_ORG
        : DisabledReasonsEnum.NONE;
    } else if (orgInviteRestrict === BoardInviteRestrictValues.MANAGED) {
      return !isInEnt
        ? DisabledReasonsEnum.RESTRICT_MANAGED
        : DisabledReasonsEnum.NONE;
    } else if (orgInviteRestrict === BoardInviteRestrictValues.ORG_OR_MANAGED) {
      return !(isInOrg || isInEnt)
        ? DisabledReasonsEnum.RESTRICT_MANAGED_OR_ORG
        : DisabledReasonsEnum.NONE;
    }
  } else if (!org) {
    return DisabledReasonsEnum.GUEST_INVITE;
  }
  return DisabledReasonsEnum.NONE;
};
